import type { User } from '@models/user';
import { apiClient } from '@api/client';

export async function getMe(): Promise<User> {
  const { data } = await apiClient.get<User>('/users/me');

  return data;
}

export async function logoutMe(): Promise<User> {
  const { data } = await apiClient.post<User>('/auth/logout');

  return data;
}

export async function getUser(id: string): Promise<User> {
  const { data } = await apiClient.get<User>(`/users/${id}`);

  return data;
}

export async function updateUser(id: string, user: User): Promise<User> {
  const { data } = await apiClient.patch<User>(`/users/${id}`, user);

  return data;
}

export async function getUsers(): Promise<User[]> {
  const { data } = await apiClient.get<User[]>('/users');

  return data;
}
